module.exports = __webpack_public_path__ + "static/img/LOGO_ei.0009ecce.svg";